import { h, FunctionalComponent } from "preact";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { isMobileOnly as isMobileOnlyReact } from "react-device-detect";
import { Labels } from "../../models/labels";
import Header from "../Header";
import { useEffect, useState } from "preact/hooks";
import PortalSearchField from "../PortalSearchField";
import {
  setKapps,
  setTags,
  setExactMatch,
  // setLastExactMatch,
  setSelectedCategory,
  setSelectedFilters,
  setNestedTags,
} from "../../redux/slices/searchSlice";
import { initialSelectedFilters } from "../../models/consts";
import axios from "axios";
import { get_AI_URI_BASE } from "../../configs/env";
import { convertJson } from "../../utils";
import { TreeNode } from "../../models/interfaces";
import AIToggle from "../AIToggle";
interface IProps {
  workspaceId?: string;
  portalId?: string;
  isPaying?: boolean;
  portalAlias?: string;
  workspaceAlias?: string;
  kappId?: string;
  mode?: string;
  value?: string;
  showBack?: boolean;
  isDrawerOpen?: boolean;
  isInnerFullScreen?: any;
  handleUpdateNestedTags?: () => void;
}
const BackgroundBanner: FunctionalComponent<IProps> = ({
  workspaceId,
  portalId,
  isPaying,
  portalAlias,
  workspaceAlias,
  kappId,
  mode,
  value,
  showBack,
  isDrawerOpen,
  isInnerFullScreen,
  handleUpdateNestedTags,
}) => {
  const dispatch = useAppDispatch();
  const appearance = useAppSelector((state) => state.appearance);
  const search = useAppSelector((state) => state.search);
  const alias = useAppSelector((state) => state.alias);
  const [homeUrl, setHomeUrl] = useState("");
  const isMobileOnly = appearance.narrowfactor || isMobileOnlyReact;
  const [active, setActive] = useState("Smart Search");

  const handleExpandView = () => {
    if (alias.workspaceAlias && alias.portalAlias) {
      //   alias.portalAlias
      // }`;
      // window.open(window.location.href, "_blank");
      // Get the current URL
      const currentUrl = new URL(window.location.href);

      // Check if 'mode' parameter exists and its value is 'widget'
      if (currentUrl.searchParams.get("mode") === "widget") {
        // Remove the 'mode' query parameter
        currentUrl.searchParams.delete("mode");
      }

      // Open the updated URL in a new tab
      window.open(currentUrl.toString(), "_blank");
    } else {
      // window.open(window.location.href, "_blank");
      // Get the current URL
      const currentUrl = new URL(window.location.href);

      // Check if 'mode' parameter exists and its value is 'widget'
      if (currentUrl.searchParams.get("mode") === "widget") {
        // Remove the 'mode' query parameter
        currentUrl.searchParams.delete("mode");
      }

      // Open the updated URL in a new tab
      window.open(currentUrl.toString(), "_blank");
    }
  };
  useEffect(() => {
    goHome(true);
  }, [appearance.showHomePageFilter, workspaceAlias, portalAlias]);
  const handleClearNestedTags = async () => {
    const nestedTagesResponse = await axios(
      `${get_AI_URI_BASE()}/doc-tagger/get_tag_trees/workspace_id/${
        workspaceId || alias.workspaceId
      }/kapps/${search?.kapps?.map((kapp) => kapp.id).join(",")}`
    );
    if (nestedTagesResponse?.data) {
      // Convert JSON data to the hierarchical structure
      const convertedData: TreeNode[] = Object.entries(
        nestedTagesResponse?.data
      ).map(([key, value]: any) => convertJson(value, key));
      let data = {
        children: convertedData,
      };
      dispatch(setNestedTags(data));
    }
  };
  const goHome = async (flag?: boolean) => {
    let detail: string;
    if (workspaceAlias && portalAlias) {
      detail = `/${workspaceAlias}/${portalAlias}`;
    } else {
      detail =
        portalId && portalId?.length > 0
          ? `/workspace/${workspaceId}/portal/${portalId}/home`
          : `/workspace/${workspaceId}/kapp/${kappId}/home`;
    }
    const tempKapp = search.kapps.map((kapp: any) => {
      if (kapp.selected) {
        return { ...kapp, selected: false }; // Create a new object with `selected` updated
      }
      return kapp; // Return the original object if no change is needed
    });
    const tempTags = search.tags.map((tag: any) => {
      if (tag.selected) {
        return { ...tag, selected: false }; // Create a new object with `selected` updated
      }
      return tag; // Return the original object if no change is needed
    });
    setHomeUrl(`${window.location.protocol}//${window.location.host}` + detail);
    if (!flag) {
      dispatch(setKapps(tempKapp));
      dispatch(setTags(tempTags));
      if (search.selectedNestedTags?.length > 0) {
        handleClearNestedTags();
      }
      dispatch(setSelectedFilters(initialSelectedFilters));
      dispatch(setExactMatch(""));
      dispatch(setSelectedCategory([]));
      (window as any).dispatchEvent(
        new CustomEvent("route-to", {
          detail,
        })
      );
    }
  };
  return (
    <div
      style={{
        transition: "height .2s ease-in-out",
        height: `${
          appearance.mode === "widget"
            ? "36vh"
            : isMobileOnlyReact
            ? "34vh"
            : "40vh"
        }`,
        // width: "100vw",
        backgroundImage: ` linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${
          appearance.backgroundImage
            ? appearance.backgroundImage
            : appearance.loaded
            ? "/assets/cover2.png"
            : ""
        }?)`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column",
        // justifyContent:
        //   !appearance.backgroundImage && !appearance.logoSrc
        //     ? "center"
        //     : "flex-start",
      }}
    >
      <div ref={isInnerFullScreen}>
        <Header
          handleExpandView={handleExpandView}
          isPaying={isPaying}
          goHome={goHome}
          homeUrl={homeUrl}
        />
      </div>
      <PortalSearchField
        workspaceId={workspaceId || alias.workspaceId}
        kappId={kappId || ""}
        portalId={portalId || alias.portalId}
        workspaceAlias={workspaceAlias}
        portalAlias={portalAlias}
        placeHolder={
          appearance.loaded && appearance.searchBarPlaceHolder
            ? appearance.searchBarPlaceHolder
            : appearance.loaded &&
              active === "Keyword Search" &&
              !appearance.searchBarPlaceHolder
            ? "Enter search terms here "
            : appearance.loaded && !isMobileOnly && appearance.mode !== "widget"
            ? Labels.SEARCH
            : appearance.loaded &&
              (isMobileOnly || appearance.mode === "widget")
            ? Labels.SEARCH_MOBILE
            : ""
        }
        isDrawerOpen={isDrawerOpen}
        value={value}
        showHomeButton={showBack}
        handleUpdateNestedTags={handleUpdateNestedTags}
        handleClearNestedTags={handleClearNestedTags}
        active={active}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          position: "relative",
          bottom: "50px",
        }}
      >
        {appearance.loaded && appearance.enableKeywordToggle && (
          <AIToggle value={value} active={active} setActive={setActive} />
        )}
      </div>
    </div>
  );
};

export default BackgroundBanner;
